'use strict';

class UpgradeModel {
  constructor(newTariffPlan, licenceId, token, method, cancelUrl, returnUrl) {
    this.newTariffPlan = newTariffPlan;
    this.licenceId = licenceId;
    this.token = token;
    this.method = method;
    this.cancelUrl = cancelUrl;
    this.returnUrl = returnUrl;
    this.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-Token': this.token
    }
    this.body = {
      newTariffPlan,
      licenceId
    }
  }

  requestInfo () {
    return fetch(`${$SUBSCRIPTIONS}/change/info?newTariffPlan=${this.newTariffPlan}&licenceId=${this.licenceId}`, {
      headers: this.headers,
      method: "GET"
    });
  }

  requestUpgrade () {
    if (this.method === "paypal") {
      this.body.cancelUrl = this.cancelUrl;
      this.body.returnUrl = this.returnUrl;
    }

    return fetch(`${$SUBSCRIPTIONS}/change`, {
      headers: this.headers,
      method: "POST",
      body: JSON.stringify(this.body)
    });
  }

}

module.exports = UpgradeModel;
